import { Movax } from './Movax';
import { SparePartCartContact } from './sparePartContactForm';

export class SparePartOrderProcess {

  private ajaxEndpoint: string;
  private language: string;
  private submitContainer: Element;
  private orderSubmitButton: Element;
  private orderSubmitButtonId: string;
  private sparePartContactForm: SparePartCartContact = new SparePartCartContact();

  constructor() {
    this.ajaxEndpoint = '/stage-ajax/sparepart_cart/';
    this.language = document.documentElement.lang;
    this.submitContainer = document.querySelector('.js-sparepart-order-submit');
    this.orderSubmitButtonId = 'js-submit-sparepart-order';
    this.orderSubmitButton = document.getElementById(this.orderSubmitButtonId);
  }

  public attachListeners() {

    const shoppingTermsCheckbox = <HTMLInputElement>document.getElementById('js-shopping-terms');

    if (shoppingTermsCheckbox) {
      shoppingTermsCheckbox.addEventListener('change', () => {
        shoppingTermsCheckbox.checked ? this.enableSubmit() : this.disableSubmit();
      });
    }

    //order submit button
    if (this.orderSubmitButton) {
      this.orderSubmitButton.addEventListener('click', this.submitOrder.bind(this), false)
    }

  }

  /**
   * enabled order submit button
   */
  public enableSubmit() {
    this.orderSubmitButton.removeAttribute('disabled');
  }

  /**
   * disable order submit button
   */
  public disableSubmit() {
    this.orderSubmitButton.setAttribute('disabled', 'disabled');
  }


  /**
   * Submit Order
   *
   */
  public async submitOrder() {

    const buyer = document.getElementById('js-buyer').getAttribute('data-buyer');
    const address = document.getElementById('address-summary').getAttribute('data-addresses');

    const params = {
      action: 'processOrder',
      address: address,
      buyer: buyer,
      shippingType: document.getElementById('js-shipping-type').innerHTML,
      language: this.language
    }

    try {
      this.orderSubmitButton.classList.add('button--loading');
      this.disableSubmit();

      const result = await this.makeAjaxRequest(params);

      //clear cart page and show order details
      if (result.status === 'success') {
        this.showOrderResult(result);
      }

      //error -> show error field
      if (result.status === 'error') {
        throw new Error(result.message);
      }

    } catch (error) {
      const errorContainer =  document.getElementById('js-summary-warning');

      errorContainer.innerHTML = 'Something went wrong : ' + error.message;

    } finally {

      this.orderSubmitButton.classList.remove('button--loading');
      this.enableSubmit();

    }

  }

  /**
   * Show order result details and empty cart page content
   *
   * @param result - result from order process
   */
  public showOrderResult(result : any) {
    this.disableSubmit();
    const dom = {
      cart: document.getElementById('js-shopping-cart'),
      clearCartButton: document.getElementById('clear-cart'),
      updateCartButton: document.getElementById('js-update-cart'),
      referenceId: document.getElementById('js-reference-id'),
      contactForm: document.getElementById('sparepart-cart-contact-form')
    };

    const orderTitle = document.createElement('h3');
    orderTitle.innerHTML = result?.message + ' ' + result?.referenceId;

    //remove cart update buttons
    dom.clearCartButton.remove();
    dom.updateCartButton.remove();

    //replace cart content with ordererd items and title
    dom.cart.innerHTML = '';
    dom.cart.appendChild(orderTitle);
    dom.cart.insertAdjacentHTML('beforeend', result.itemList);

    //update also summary reference
    dom.referenceId.innerHTML = result.referenceId;

    //hide submit container
    this.submitContainer.classList.add('hidden');

    //remove contact form
    dom.contactForm.remove();

    //empty invoice and shipping details from local storage
    this.sparePartContactForm.removeContactDetails();
  }

  /**
   * Make ajax request
   *
   * @param params parameters as object or serialized string
   * @returns {object} return object should contain status, message, data
   */
  private async makeAjaxRequest(params: object){

    if (!this.ajaxEndpoint) {
      throw new Error('Form submission failed. Endpoint undefined.');
    }

    return Movax.xhr.get(this.ajaxEndpoint, params);
  }

}
